import * as React from "react";
import type { SVGProps } from "react";
const SvgCoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={74}
    height={40}
    fill="none"
    viewBox="0 0 74 40" {...props}
  >
    <ellipse
      cx={46.737}
      cy={33.395}
      fill="url(#coin_svg__a)"
      rx={27.263}
      ry={6.6}
    />
    <ellipse
      cx={27.263}
      cy={20.855}
      fill="url(#coin_svg__b)"
      rx={27.263}
      ry={6.6}
    />
    <path
      fill="url(#coin_svg__c)"
      fillOpacity={0.6}
      d="M25.441 16.34c-8.04 0-14.559-1.94-14.559-4.334v8.667c0 2.393 6.519 4.333 14.56 4.333 8.04 0 14.558-1.94 14.558-4.333v-8.667c0 2.393-6.518 4.333-14.559 4.333"
    />
    <path
      fill="url(#coin_svg__d)"
      fillOpacity={0.6}
      d="M25.441 8.006c8.04 0 14.559 2.015 14.559 4.5s-6.518 4.5-14.559 4.5c-8.04 0-14.559-2.015-14.559-4.5s6.519-4.5 14.56-4.5"
    />
    <path
      fill="url(#coin_svg__e)"
      fillOpacity={0.6}
      d="M23.677 7.673C16.123 7.673 10 6.03 10 4.006v7.333c0 2.025 6.123 3.667 13.677 3.667s13.676-1.642 13.676-3.667V4.006c0 2.025-6.123 3.667-13.676 3.667"
    />
    <path
      fill="url(#coin_svg__f)"
      fillOpacity={0.6}
      d="M23.677.006c7.553 0 13.676 1.79 13.676 4s-6.123 4-13.676 4c-7.554 0-13.677-1.79-13.677-4s6.123-4 13.677-4"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M29.175 4.353c.062 0 .115-.01.141-.054a1 1 0 0 0 .032-.068 1 1 0 0 1 .039-.085v-.021a.26.26 0 0 0-.044-.131.17.17 0 0 0-.141-.065h-.009l-.88-.033a2 2 0 0 0-.239-.62 1.9 1.9 0 0 0-.467-.534 2.2 2.2 0 0 0-.713-.392 3.1 3.1 0 0 0-.952-.174h-.044a2.9 2.9 0 0 0-1.013.098 2.5 2.5 0 0 0-1.286.838c-.159.185-.3.381-.44.577l-3.146-.109c.018-.163.053-.294.115-.414a.7.7 0 0 1 .3-.294c.131-.087.316-.152.537-.206.229-.055.502-.098.837-.142.044 0 .079-.01.088-.044q.015-.032.017-.065v-.022a.15.15 0 0 0-.035-.087.1.1 0 0 0-.07-.032h-.01c-.114 0-.22 0-.325.01q-.081 0-.156.006l-.144.005c-.097.011-.193.011-.29.011-.065.007-.133.005-.202.003l-.107-.003h-.088c-.15-.01-.282-.022-.405-.032a3 3 0 0 1-.45-.066h-.017c-.026 0-.053 0-.07.022a.09.09 0 0 0-.036.076v.011c0 .033.01.055.018.076q.013.05.08.066c.052.021.078.043.096.065a.3.3 0 0 1 .018.087c0 .033 0 .087-.018.13l-.016.046a1 1 0 0 1-.054.129 2.5 2.5 0 0 0-.124.316 1.2 1.2 0 0 0-.052.326l-.705-.021c-.062-.011-.106.01-.133.054a.26.26 0 0 0-.035.142v.01a.4.4 0 0 0 .053.131q.042.066.123.066l.732.021c.026.23.097.436.194.643.096.207.237.381.414.544q.264.245.66.392c.265.098.564.164.916.175h.027c.37.01.687-.022.943-.11.264-.076.484-.184.67-.326.184-.142.343-.294.475-.48l.127-.175q.134-.182.26-.369l.045-.054.035-.055 3.559.131c0 .196-.062.37-.168.534a1.5 1.5 0 0 1-.458.424c-.202.12-.431.218-.704.294a4.5 4.5 0 0 1-.917.153c-.052.01-.088.022-.105.054a.2.2 0 0 0-.018.077v.021c.009.044.026.066.062.098a.15.15 0 0 0 .097.033h.026l.05-.002c.218-.01.424-.02.628-.02.22 0 .441 0 .661.011h.053c.203.011.396.022.6.044.22.021.422.043.616.065h.017c.018 0 .036-.01.053-.022.027-.022.035-.043.044-.076v-.033c0-.01-.009-.032-.017-.054q-.016-.033-.097-.065a.8.8 0 0 1-.282-.142c-.053-.044-.08-.087-.08-.12 0-.032.01-.065.018-.098q.013-.016.027-.038l.026-.038c.07-.076.123-.163.176-.25.053-.088.088-.175.124-.273.026-.087.052-.185.07-.272.018-.098.018-.185.018-.261zm-1.784-1.166a2.283 2.283 0 0 0-1.185-.352h-.022a3.2 3.2 0 0 0-.771.059 3.2 3.2 0 0 0-.604.22 2 2 0 0 0-.48.337 4 4 0 0 0-.37.396l4.036.147a1.6 1.6 0 0 0-.235-.44 1.3 1.3 0 0 0-.369-.367m-7.316 1.24c.075.14.178.265.29.363.122.111.263.181.422.25.16.07.328.099.525.113h.018c.235.014.431-.014.61-.07a1.546 1.546 0 0 0 .759-.572c.093-.126.177-.266.252-.392l-3.026-.125c.019.153.075.293.15.433"
      clipRule="evenodd"
    />
    <path
      fill="url(#coin_svg__g)"
      d="M45.841 27.336c8.85 0 16.023-2.04 16.023-4.555v9.11c0 2.517-7.173 4.556-16.023 4.556s-16.023-2.04-16.023-4.555v-9.11c0 2.515 7.174 4.554 16.023 4.554"
      opacity={0.9}
    />
    <path
      fill="#27DFD1"
      d="M45.841 18.815c-8.85 0-16.023 2.04-16.023 4.555 0 2.516 7.174 4.556 16.023 4.556s16.023-2.04 16.023-4.556-7.173-4.555-16.023-4.555"
    />
    <path
      fill="url(#coin_svg__h)"
      d="M43.773 18.226c8.85 0 16.024-2.04 16.024-4.556v9.11c0 2.517-7.174 4.556-16.024 4.556s-16.023-2.04-16.023-4.555v-9.11c0 2.515 7.174 4.555 16.023 4.555"
      opacity={0.9}
    />
    <path
      fill="#27DFD1"
      d="M43.773 9.41c-8.85 0-16.023 2.04-16.023 4.555 0 2.516 7.174 4.555 16.023 4.555s16.024-2.04 16.024-4.555c0-2.516-7.174-4.555-16.024-4.555"
    />
    <path
      fill="url(#coin_svg__i)"
      d="M49.977 9.115C58.827 9.115 66 7.075 66 4.559v9.111c0 2.516-7.174 4.555-16.023 4.555s-16.024-2.04-16.024-4.555V4.56c0 2.515 7.174 4.555 16.024 4.555"
      opacity={0.9}
    />
    <path
      fill="#27DFD1"
      d="M49.977.004c-8.85 0-16.024 2.04-16.024 4.556s7.174 4.555 16.024 4.555S66 7.075 66 4.56C66 2.044 58.826.004 49.977.004"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M58.609 4.77c.087 0 .161-.015.198-.075a1 1 0 0 0 .045-.095q.02-.05.054-.117v-.03a.35.35 0 0 0-.062-.182.24.24 0 0 0-.198-.09h-.012l-1.24-.046a2.8 2.8 0 0 0-.335-.862 2.7 2.7 0 0 0-.657-.74 3.2 3.2 0 0 0-1.005-.545 4.4 4.4 0 0 0-1.339-.242h-.062c-.546-.03-1.03.015-1.426.136a3.494 3.494 0 0 0-1.81 1.165c-.224.257-.422.529-.62.801l-4.427-.151c.025-.227.074-.409.161-.575a.97.97 0 0 1 .422-.408c.186-.121.446-.212.756-.288a12 12 0 0 1 1.178-.196c.062 0 .112-.015.124-.06.013-.031.025-.061.025-.092v-.03a.2.2 0 0 0-.05-.12.13.13 0 0 0-.099-.046h-.012c-.161 0-.31 0-.459.015q-.114.001-.22.008-.102.006-.202.007c-.136.015-.272.015-.409.015-.09.01-.186.007-.284.004q-.075-.004-.15-.004h-.124c-.21-.015-.397-.03-.57-.045a4.6 4.6 0 0 1-.633-.09h-.024c-.038 0-.075 0-.1.03a.12.12 0 0 0-.05.105v.015c0 .046.013.076.026.106q.019.069.111.09a.3.3 0 0 1 .137.092c.012.03.024.075.024.12 0 .046 0 .122-.024.182q-.011.028-.024.063a1 1 0 0 1-.076.18 3.4 3.4 0 0 0-.173.438c-.05.136-.062.287-.075.454l-.991-.03c-.087-.016-.15.014-.186.075a.35.35 0 0 0-.05.196v.016q.018.09.074.181c.038.06.1.09.174.09l1.03.031c.036.318.136.605.272.892s.335.53.583.757q.372.34.93.544a4 4 0 0 0 1.29.242h.036c.521.015.968-.03 1.327-.151a2.8 2.8 0 0 0 .942-.454c.26-.196.484-.408.67-.665l.179-.245c.125-.17.249-.337.367-.512l.062-.075.05-.076 5.009.182c0 .272-.087.514-.236.74a2.1 2.1 0 0 1-.645.59 4 4 0 0 1-.992.409 6.4 6.4 0 0 1-1.29.212c-.074.015-.123.03-.148.075a.3.3 0 0 0-.025.106v.03c.013.061.038.091.087.137.037.03.087.045.136.045h.038l.069-.003a20 20 0 0 1 1.815-.012h.075c.285.015.558.03.843.06.31.03.595.06.868.091h.025c.025 0 .05-.015.074-.03.037-.03.05-.06.062-.106v-.045c0-.016-.012-.046-.025-.076-.012-.03-.062-.06-.136-.09a1.2 1.2 0 0 1-.397-.197c-.074-.06-.111-.121-.111-.167 0-.045.012-.09.024-.136l.038-.053q.018-.03.037-.053c.099-.106.173-.227.248-.348.074-.12.124-.242.173-.378a4 4 0 0 0 .1-.378c.024-.136.024-.257.024-.363zm-2.511-1.62a2.8 2.8 0 0 0-.755-.346 3.3 3.3 0 0 0-.913-.142H54.4c-.41-.02-.755.02-1.086.081a4.6 4.6 0 0 0-.85.306 3 3 0 0 0-.676.468 6 6 0 0 0-.519.55l5.68.204a2.2 2.2 0 0 0-.331-.611c-.126-.204-.315-.367-.52-.51M45.8 4.872c.106.194.25.369.409.504.171.155.369.252.593.35.224.096.462.135.739.154h.026c.33.02.607-.019.857-.096a2.156 2.156 0 0 0 1.068-.795c.132-.175.25-.369.356-.544l-4.259-.174c.026.213.105.407.211.601"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="coin_svg__c"
        x1={33.998}
        x2={32.848}
        y1={25.006}
        y2={18.453}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B61DA" />
        <stop offset={1} stopColor="#0084FF" />
      </linearGradient>
      <linearGradient
        id="coin_svg__d"
        x1={33.998}
        x2={33.438}
        y1={17.006}
        y2={12.398}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B61DA" />
        <stop offset={1} stopColor="#0084FF" />
      </linearGradient>
      <linearGradient
        id="coin_svg__e"
        x1={31.715}
        x2={30.833}
        y1={15.006}
        y2={9.43}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B61DA" />
        <stop offset={1} stopColor="#0084FF" />
      </linearGradient>
      <linearGradient
        id="coin_svg__f"
        x1={31.715}
        x2={31.243}
        y1={8.006}
        y2={3.903}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B61DA" />
        <stop offset={1} stopColor="#0084FF" />
      </linearGradient>
      <linearGradient
        id="coin_svg__g"
        x1={45.841}
        x2={45.841}
        y1={22.781}
        y2={36.447}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#31A1B1" />
        <stop offset={1} stopColor="#3BD7EF" />
      </linearGradient>
      <linearGradient
        id="coin_svg__h"
        x1={43.773}
        x2={43.773}
        y1={13.67}
        y2={27.336}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#31A1B1" />
        <stop offset={1} stopColor="#3BD7EF" />
      </linearGradient>
      <linearGradient
        id="coin_svg__i"
        x1={49.977}
        x2={49.977}
        y1={4.559}
        y2={18.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#31A1B1" />
        <stop offset={1} stopColor="#3BD7EF" />
      </linearGradient>
      <radialGradient
        id="coin_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 6.60031 -27.2631 0 46.737 33.395)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#23F6E7" />
        <stop offset={0.79} stopColor="#01E1E1" stopOpacity={0.1} />
      </radialGradient>
      <radialGradient
        id="coin_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 6.60031 -27.2631 0 27.263 20.855)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2B61DA" />
        <stop offset={0.79} stopColor="#2B61DA" stopOpacity={0.1} />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgCoin;
